var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('clients-filter',{on:{"open-create-modal":_vm.openModal}}),_c('clients-table'),_c('client-create-modal',{attrs:{"show":_vm.showAddClient},on:{"update:show":function($event){_vm.showAddClient=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }